{
  "version": 1,
  "asset_id": "9dd5c3a3-5120-419b-87c9-8d49b5e350d7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/9dd5c3a3-5120-419b-87c9-8d49b5e350d7/dilated-pouch-boxed-es-980.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/9dd5c3a3-5120-419b-87c9-8d49b5e350d7/dilated-pouch-boxed-es-980.webp",
  "original_filename": "dilated-pouch-boxed-es-980.webp",
  "size": 51204,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:09:22Z"
}
